import { ListBaseModel } from '@/api/models';
import z from 'zod';

export const UsersSnapshotModel = ListBaseModel.extend({
  results: z
    .object({
      id: z.string(),
      name: z.string(),
      organizationIds: z.string().uuid().array().nullable(),
      isIntegrated: z.boolean(),
      isDeleted: z.boolean(),
      email: z.string().nullish(),
      organizations: z
        .object({
          id: z.string(),
          name: z.string(),
          code: z.string().nullish(),
        })
        .array(),
    })
    .array(),
});
